import { render, staticRenderFns } from "./InterpretationRevalidationPendingTable.vue?vue&type=template&id=7c586d96&"
import script from "./InterpretationRevalidationPendingTable.vue?vue&type=script&lang=js&"
export * from "./InterpretationRevalidationPendingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports